import React, {useCallback, useMemo, useState} from 'react';
import Card from '../elements/ReactBootstrap/Card';
import {Col, Row} from 'react-bootstrap';
import {useGetClientQuery} from '../../features/apiSlice';
import {useParams} from 'react-router-dom';
import ErrorWidget from '../widgets/ErrorWidget';
import ClientInfoWidget from '../widgets/Client/ClientInfoWidget.jsx';
import PoliciesListWidget from '../widgets/Policy/PoliciesListWidget.jsx';
import Content from '../partials/Content.jsx';
import SmallSpinner from '../elements/Spinner/SmallSpinner.jsx';
import ClientAddressesWidget from "../widgets/Client/ClientAddressesWidget.jsx";
import {format} from "date-fns";
import ExportToExcelButton from "../elements/Buttons/ExportToExcelButton.jsx";

const Client = () => {
    const {clientId} = useParams();
    const [printing, setPrinting] = useState(false);

    const {
        data: client,
        error,
        isLoading,
        isSuccess,
        isError,
    } = useGetClientQuery(clientId);

    const filterInsuredPolicies = useCallback((client, isPrevious) =>
        client.insuredPolicies.filter(insuredPolicy => insuredPolicy.isPrevious === isPrevious).map(
            insuredPolicy => insuredPolicy.policy
        ),
        [],
    );

    const currentInsuredPolicies = useMemo(
        () => isSuccess ? filterInsuredPolicies(client, false) : [],
        [isSuccess, client, filterInsuredPolicies],
    );

    const previousInsuredPolicies = useMemo(
        () => isSuccess ? filterInsuredPolicies(client, true) : [],
        [isSuccess, client, filterInsuredPolicies],
    );

    const nextPayment = useCallback(policy => policy.installments.filter(installment =>
        !installment.paidPremiumFromClient).shift(), []);

    const dataForExport = isSuccess ? client.heldPolicies.map(policy => ({
        "Номер" : policy.number,
        "Продукт": policy.productName,
        "ЗК" : policy.insuranceCompany?.shortName,
        "Консултант" : policy.issueUser?.shortName,
        "Клиент" : client?.name,
        "МПС" : policy.insuredVehicle?.plateNumber,
        "Следващо плащане" : (nextPayment(policy)?.dueDate && Date.parse(nextPayment(policy)?.dueDate)) ?
             format(new Date(nextPayment(policy)?.dueDate), 'dd.MM.yyyy')
            : Date.parse(policy?.endDate) ? format(new Date(policy?.endDate), 'dd.MM.yyyy') : '',
        "Тип" : nextPayment(policy)?.dueDate ? 'вноска' : 'подновяване',
        "Покритие от" : Date.parse(policy?.beginDate) ?(format(new Date(policy?.beginDate), 'dd.MM.yyyy')) : '',
        "Покритие до" : Date.parse(policy?.endDate) ? (format(new Date(policy?.endDate), 'dd.MM.yyyy')): '',
    })) : [];

    return (<Content title="Информация за клиент">
        <Row className="row-cols-1">
            <Col>
                {isLoading && <Card>Зареждане на клиента... <SmallSpinner /></Card>}
                {isError && <ErrorWidget error={error} />}
                {isSuccess && <Card>
                    <ClientInfoWidget client={client} printing={printing} setPrinting={setPrinting}/>
                </Card>}
                {isSuccess && <Card noPadding header={'Адреси (' +
                    client.addresses.length + ')'}>
                    <ClientAddressesWidget addresses={client.addresses} client={clientId}/>
                </Card>
                }
            </Col>
            {isSuccess && <>
                <Col>
                    <Card noPadding header={<>{'Полици, сключени от клиента (' +
                        client.heldPolicies.length + ') '}
                        <ExportToExcelButton data={dataForExport} fileName={'heldPolicies-' + client.pin} /></>}>
                        <PoliciesListWidget policies={client.heldPolicies} showClient={false} />
                    </Card>
                </Col>
                <Col>
                    <Card noPadding header={'Полици, по които клиентът е застраховано лице (' +
                        currentInsuredPolicies.length + ')'}>
                        <PoliciesListWidget policies={currentInsuredPolicies} showClient={false} />
                    </Card>
                </Col>
                <Col>
                    <Card noPadding header={'Полици, по които клиентът е бил застраховано лице (' +
                        previousInsuredPolicies.length + ')'}>
                        <PoliciesListWidget policies={previousInsuredPolicies} showClient={false} />
                    </Card>
                </Col>
                <Col>
                    <Card noPadding header={'Полици, по които клиентът е лице за контакт (' +
                        client.contactPolicies.length + ')'}>
                        <PoliciesListWidget policies={client.contactPolicies} showClient={false} />
                    </Card>
                </Col>
            </>}
        </Row>
    </Content>);
};

export default Client;
